import React from 'react';
import RouteParams from '../interfaces/RouteParams';
import { isBrand } from '../utils/utils';
import CompleteWefox from './CompleteWefox';
import CompleteTAF from './CompleteTAF';
import CompleteDHMR from './CompleteDHMR';
import Brand from '../enums/Brand';

import 'QuestionnaireTAF/QuestionnaireTAF.css';
import './Complete.css';

class Complete extends React.PureComponent<RouteParams> {
  render(): React.ReactElement {
    const {
      healthDeclarationId,
      locationSearch,
    } = this.props;

    const isWefox = isBrand(Brand.wefox);
    const isDHMR = isBrand(Brand.DHMR);

    if (isWefox) {
      return (
        <CompleteWefox healthDeclarationId={healthDeclarationId} locationSearch={locationSearch} />
      );
    }

    if (isDHMR) {
      return (
        <CompleteDHMR healthDeclarationId={healthDeclarationId} locationSearch={locationSearch} />
      );
    }

    return <CompleteTAF healthDeclarationId={healthDeclarationId} locationSearch={locationSearch} />;
  }
}

export default Complete;
